import { get, post } from '../index'
export default{
  //获取积分设置
  getIntegralSetting () {
    return get('/integralshop/IntegralSetting/get')
  },
  //积分设置
  setIntegralSetting (querys) {
    return post('/integralshop/IntegralSetting/set',querys)
  },
  //获取全部用户积分日志
  getUserIntegralLog (querys) {
    return get('/integralshop/IntegralList/list',querys)
  },
  getUserLotterylLog (querys) {
    return get('/integralshop/LotteryList/list',querys)
  },
  // 获取商品列表
  getIntegralGoodsList (querys) {
    return post('/integralshop/AdminIntegralShopGoods/goodsList', querys)
  },
  // 添加商品信息
  addIntegralGoodsInfo (querys) {
    return post('/integralshop/AdminIntegralShopGoods/goodsAdd', querys)
  },
  // 编辑商品信息
  editIntegralGoodsInfo (querys) {
    return post('/integralshop/AdminIntegralShopGoods/goodsUpdate', querys)
  },
}



// WEBPACK FOOTER //
// ./src/api/modules/integral.js